<app-core-ui-sidebar class="sidebar mat-body-large"/>
<app-core-ui-header class="header"/>
<app-core-ui-breadcrumb class="breadcrumb"/>
<div class="router">
  @if (wasWildCardRouted() && extjsService.scope() === "core") {
    <app-core-page-extjs [style.display]="ready() ? 'flex' : 'none' "/>
  }
  <router-outlet/>
</div>
<app-notification-menu/>

